export const en = {
  msg:
    {
      'login': 'Login',
      'username_error_required': 'Please enter your username.',
      'password_error_required': 'Please enter your password.',
      'error': 'Invalid username or password',
      'blank_username_field': 'Please enter your username.',
      'blank_password_field': 'Please enter your password.',
      'invalid_credentials': 'Please enter a valid username or password.',
      'copyright': 'Powered by Global Psytech',
      'username_label': 'Username',
      'password_label': 'Password',
      'serverError': 'Sorry, something went wrong. Please try again.',
      'footer_text': 'Global Psytech Sdn. Bhd.',
      'login_button': 'Login',
      'expired_validity': 'Your user account has expired'
    }
}
